import { render, staticRenderFns } from "./ProductContentListItem.vue?vue&type=template&id=12941ac2&scoped=true"
import script from "./ProductContentListItem.vue?vue&type=script&lang=js"
export * from "./ProductContentListItem.vue?vue&type=script&lang=js"
import style0 from "./ProductContentListItem.vue?vue&type=style&index=0&id=12941ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12941ac2",
  null
  
)

export default component.exports